import { LevelModel } from '@/types';
import BaseService from '@/services/api/BaseService';

class LevelService extends BaseService<LevelModel> {}

export default new LevelService('levels');
